module.exports = __webpack_public_path__ + "static/a-guide-to-the-good-life-08891ea2d81aaddd68931af569c67fbf.jpg";